// map state
export const setCenter = (state, latlng) => { state.center = latlng }
export const setZoom = (state, zoom) => { state.zoom = zoom }

// current weather
export const setWeather = (state, weather) => { state.weather = weather }

// user position
// export const setWatchid = (state, watchid) => { state.watchid = watchid }
// export const clearWatchid = state => {
//   if (state.watchid) navigator.geolocation.clearWatch(state.watchid)
//   state.watchid = null
// }
export const setPosition = (state, position) => {
  state.position = position
}

export const setPoisTrack = (state, bool) => {
  localStorage.setItem('pois-track', bool)
  state.poisTrack = bool
}

export const setPois = (state, oPois) => {
  const ids = Object.keys(oPois)
  for (let id of ids) {
    if (!state.pois[id]) {
      state.pois[id] = oPois[id]
      state.poisIdx.push(id)
    }
  }
}
